// Kept in a plain .ts module (no JSX) so the constants can be exported without
// triggering the react-refresh/only-export-components ESLint rule.
import { FeedOriginKind } from '@/types/gql.generated';

export type FeedIconType = 'google' | 'outlook' | 'logo' | 'rss';

export type FeedTypeMeta = {
  iconType: FeedIconType;
  label: string;
};

// Maps a feed's origin kind to its display icon + label. Google calendars get the
// Google "G", experience-backed feeds get the Agenda Hero mark, and ICS (and any
// future) calendar subscriptions fall back to the RSS glyph.
export const getFeedTypeMeta = (kind: FeedOriginKind): FeedTypeMeta => {
  switch (kind) {
    case FeedOriginKind.Google:
      return { iconType: 'google', label: 'Google Calendar' };
    case FeedOriginKind.Outlook:
      return { iconType: 'outlook', label: 'Outlook Calendar' };
    case FeedOriginKind.Experience:
      return { iconType: 'logo', label: 'Agenda Hero Experience' };
    default:
      return { iconType: 'rss', label: 'Calendar feed' };
  }
};
